import React, { useState } from "react";
import UserProfileView from "./UserProfileView";
 import classNames from "classnames";
import UserChangePassword from "./UserChangePassword";

const ProfileView = () => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState("userProfileTab");

  return (
    <section className="contact py-80">
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar with tabs */}
          <div className="col-lg-3">
            <div className="list-group common-tab">
              <div className="nav-item">
                <a
                  href="#userProfileTab"
                  className={classNames("nav-link", {
                    active: activeTab === "userProfileTab", // Conditionally apply active class
                  })}
                  data-bs-toggle="list"
                  role="tab"
                  onClick={() => setActiveTab("userProfileTab")} // Set active tab on click
                >
                  User Profile
                </a>
              </div> 
              <div className="nav-item">
                <a
                  href="#ResetPasswordTab"
                  className={classNames("nav-link", {
                    active: activeTab === "ResetPasswordTab", // Conditionally apply active class
                  })}
                  data-bs-toggle="list"
                  role="tab"
                  onClick={() => setActiveTab("ResetPasswordTab")} // Set active tab on click
                >
                  Reset Password
                </a>
              </div>
            </div>
          </div>

          {/* Main content */}
          <div className="col-lg-9">
            <div className="tab-content">
              {/* User Profile Tab */}
              <div
                className={classNames("tab-pane fade", {
                  "show active": activeTab === "userProfileTab", // Conditionally apply active class to content
                })}
                id="userProfileTab"
                role="tabpanel"
              >
                <UserProfileView />
              </div>

               {/* ResetPasswordTab */}
               <div
                className={classNames("tab-pane fade", {
                  "show active": activeTab === "ResetPasswordTab", // Conditionally apply active class to content
                })}
                id="ResetPasswordTab"
                role="tabpanel"
              >
                <UserChangePassword />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileView;
